import http, { authHeader } from './http';

// Получить информацию о ссылке (без активации, публичный)
export const getAccessLinkInfo = (token) =>
  http.get(`/api/access-links/${token}`).then((r) => r.data);

// Активировать ссылку (требует JWT-токен пользователя)
export const redeemAccessLink = (authToken, linkToken) =>
  http
    .post(`/api/access-links/${linkToken}/redeem`, {}, { headers: authHeader(authToken) })
    .then((r) => r.data);

// Админские функции
export const listAccessLinks = (token, params) =>
  http.get('/api/admin/access-links', { params, headers: authHeader(token) }).then((r) => r.data);

export const createAccessLink = (token, data) =>
  http.post('/api/admin/access-links', data, { headers: authHeader(token) }).then((r) => r.data);

export const deleteAccessLink = (token, id) =>
  http.delete(`/api/admin/access-links/${id}`, { headers: authHeader(token) }).then((r) => r.data);
